import axios from 'axios';
import apiUrl from '../../../constants'

export default new class {
	async traceIP(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.iptracker_url + 'UserTracker',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getPickupCountDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPickupCountDetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getShipmentCountDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getShipmentCountDetails',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getHubSRuserList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/GetHubSRuserList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTripDetails(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTripDetailById',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTripDataList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'gettripDetailsList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTripCloseReasons(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getTripCloseReasonList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getTripPickupAllocationData(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getPickupAllocationData',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async closeTrip(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'closeTrip',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getSRUserList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/GetHubUserList',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async forceLogout(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/ForceLogoutUser',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async getHubAccessList(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/getHubListaccessForUser',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
	async updateCurrentHub(input) {
		try {
			let result = await axios({
				method: 'POST',
				'url': apiUrl.api_url + 'external/UpdateCurrentHub',
				'data': input,
			})
			return result;
		} catch (err) {
			throw new Error(err);
		}
	};
}



// WEBPACK FOOTER //
// ./src/modules/cargoallocation/services/cargoallocation.service.js